/** @param {string} template @param {Record<string, string | number>} [vars] */
export function formatMsg(template, vars = {}) {
  if (typeof template !== 'string') return String(template ?? '');
  return template.replace(/\{(\w+)\}/g, (_, key) =>
    vars[key] !== undefined && vars[key] !== null ? String(vars[key]) : `{${key}}`
  );
}
